import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import BaseLayout from './../../templates/base';
import Loading from './../../elements/loading';
import InmPagination from "../../elements/widgets/inmPagination";
import {confirmAlert} from "react-confirm-alert";
import _ from 'lodash';
import EntityAdd from './../../elements/entities/widget/entity_add';
import EntitySearch from './../../elements/entities/widget/entity_search';

class Entities extends Component {
	render (){
		return(
			<EntitiesList {...this.props}/>
		);
	}

	componentWillMount() {
		const { entities } = this.props;
		this.props.entitiesShow(entities.pages.current, entities.filters);
	}
}

export class EntitiesList extends Component {
	render(){
		const { entities } = this.props;
		let eu = _.find(entities.permissions, (o) => {return o==='Update'});
		let ed = _.find(entities.permissions, (o) => {return o==='Delete'});
		return (
			<div>
				{entities.isFetching ? <Loading/>:
					<table className={`inm-table`}>
						<thead>
							<tr>
								<th>ID</th>
								<th>Código</th>
								<th>Nombre</th>
								<th>Short</th>
							</tr>
						</thead>
						<tbody>
							{_.map(entities.list, (row, k) => {
								return (
									<tr key={k}>
										<td style={{width:10+'%'}}>
											<div className="actions">
												{eu ? <NavLink to={`/entidades/editar/${row.id}`}><i className="fa fa-edit"></i></NavLink>:''}
												{ed ? <button onClick={() => this._getConfirm(row.id, row.name)}><i className="fa fa-trash-o"></i></button>:''}
											</div>
											{row.id}
										</td>
										<td>{row.code}</td>
										<td><strong>{row.name}</strong></td>
										<td>{row.short}</td>
									</tr>
								);
							})}
						</tbody>
					</table>}
				{entities.pages.total>20 &&
					<InmPagination key="concepts-pages"
					               current={entities.pages.current}
					               total={entities.pages.total}
					               nextPage={this._handlePageChange}
					/>}
			</div>
		);
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el estado "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.deleteEntity(id)
		})
	}

	_handlePageChange(value) {
		const { entities } = this.props;
		this.props.entitiesShow(value, entities.filters);
	}
}

//export default BaseLayout(Entities, {title: `Administrar Entidades`, subnav: {icon: 'fa-map', name: 'Administración', actions: {url: '/entidades/crear', name: 'Agregar Entidad'}}, search:'entities'});
export default BaseLayout(Entities, {
	title: `Administrar Entidades`,
	subnav: {
		icon: 'fa-map',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Buscar',
				element: <EntitySearch />
			},
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <EntityAdd />
			}
		]
	}
});




// WEBPACK FOOTER //
// ./src/layouts/entities/index.jsx